import BaseApiRequest from "./BaseApiRequest";
import { PRODUCT_VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetProductVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return PRODUCT_VAULT_URL;
  };

  getBody = () => {
    return this.body;
  };
}
